import ApiClient from '@/api/ApiClient';

const client = new ApiClient('agency/plugin');

class PluginApiAgency {
	static request (requestPluginModel: IRequestPluginModel) {
		return client.post<void>('request', requestPluginModel);
	}
}

export default PluginApiAgency;
